import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    columnName: String
  }

  static targets = ["editButton", "cancelButton", "hiddenColumn", "addButton", "deleteButton", "checkbox"]

  toggleEdit() {
    const showCheckbox = this.editButtonTarget.classList.contains("hidden") === false

    // Toggle between edit and cancel buttons
    this.editButtonTarget.classList.toggle("hidden")
    this.cancelButtonTarget.classList.toggle("hidden")

    // Show/hide columns
    this.hiddenColumnTargets.forEach(column => {
      if (showCheckbox) {
        column.classList.remove("hidden")
      } else {
        column.classList.add("hidden")
      }
    })

    // toggle add button
    if (showCheckbox) {
      this.addButtonTarget.classList.add('hidden')
    } else {
      this.addButtonTarget.classList.remove('hidden')
    }

    // toggle bulk delete button
    if (!showCheckbox) {
      this.deleteButtonTarget.classList.add('hidden')
    } else {
      this.deleteButtonTarget.classList.remove('hidden')
      this.updateDeleteButtonState()
    }
  }

  // Called when any checkbox changes
  selectRow() {
    this.updateDeleteButtonState()
  }

  updateDeleteButtonState() {
    const anyChecked = this.checkboxTargets.some(cb => cb.checked)
    this.deleteButtonTarget.disabled = !anyChecked
    this.deleteButtonTarget.classList.toggle('opacity-50', !anyChecked)
    this.deleteButtonTarget.classList.toggle('cursor-not-allowed', !anyChecked)
  }

  // Handle form submission
  submitForm(event) {
    const checkedBoxes = this.checkboxTargets.filter(cb => cb.checked)
    if (checkedBoxes.length === 0) {
      event.preventDefault()
      return
    }

    // Add selected user IDs to form data
    const form = event.target.closest('form')

    checkedBoxes.forEach(checkbox => {
      const hiddenField = document.createElement('input')
      hiddenField.type = 'hidden'
      hiddenField.name = `${this.columnNameValue}_ids[]`
      hiddenField.value = checkbox.value
      form.appendChild(hiddenField)
    })

    this.toggleEdit();
  }
}
